//检查手机号码
export function checkPhoneNumber (phoneNumber, that) {
  // const reg = /^0?(13[0-9]|15[012356789]|18[0-9]|14[578]|16[6]|17[035768]|19[19])[0-9]{8}$/
  // 中国大陆手机号正则表达式
  // 支持号段：130-199
  const reg = /^0?1[3-9]\d{9}$/
  if ( !reg.test(phoneNumber) ) {
    that.$message({
      showClose: true,
      duration: 2000,
      message: '请输入合法的手机号',
      type: 'warning'
    })
    return false
  }else {
    return true
  }

}



// WEBPACK FOOTER //
// ./src/util/checkNumberTools.js